import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import ImmersiveShoppingExperience from './components/ImmersiveShoppingExperience';
import Login from './components/Login';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './App.css';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutPopup();
  };

  return (
    <Elements stripe={stripePromise}>
      {isAuthenticated ? (
        <ImmersiveShoppingExperience />
      ) : (
        <Login />
      )}
    </Elements>
  );
}

export default App;